/**
 * Modules queries for TanStack Query (Vendor App)
 */

import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { queryKeys } from '../keys'
import { queryGet } from '../utils/request'

// Type definitions
export interface Quota {
  id: number
  name: string
  description: string
  required?: boolean
  value?: string | number | null
}

export interface Resource {
  id: number
  name: string
  description: string
  required?: boolean
  enabled?: boolean
  quotas?: Quota[]
}

export interface Module {
  id: number
  name: string
  description: string
  code?: string
  resources?: Resource[]
}

export interface ModuleListParams {
  search?: string
  [key: string]: any
}

export interface ModuleListResponse {
  items: Module[]
  total?: number
}

// Cache configuration
const CACHE_TIMES = {
  MODULES: 30 * 60 * 1000, // 30 minutes - modules rarely change
}

/**
 * QUERIES
 */

/**
 * Query hook to fetch all modules
 */
export const useModulesQuery = (params: MaybeRefOrGetter<ModuleListParams> = {}) => {
  return useQuery({
    queryKey: computed(() => queryKeys.moduleList(toValue(params))),
    queryFn: async (): Promise<ModuleListResponse> => {
      return queryGet<ModuleListResponse>('/v1/modules/')
    },
    staleTime: CACHE_TIMES.MODULES,
  })
}
